import React from "react";
import { Divider, Modal } from "antd";

import styles from "../Ponude.module.scss";
import { formatNumber } from "../../../helpers/formater";

const OfferDetailsModal = ({ detailsModal, setDetailsModal, currentOffer }) => {
  console.log(currentOffer);
  return (
    <Modal
      className={styles.details}
      style={{
        top: 20,
      }}
      title="DETALJI PONUDE"
      open={detailsModal}
      onCancel={() => setDetailsModal(false)}
    >
      <Divider className="bg-white h-[2px] mt-4" />
      <div className="flex flex-col gap-1">
        <p>Broj ponude: {currentOffer.offerNumber} </p>
        <p>Trajanje(mjeseci): {currentOffer.duration * 12}</p>
        <p>Broj rata: {currentOffer.duration * 12}</p>
        <p>Vrsta leasinga: {currentOffer.leaseType}</p>
        <p>Objekt leasinga: {currentOffer.assetType}</p>
        <p>Naziv obračuna: {currentOffer.calculationType} </p>
      </div>
      <Divider className="bg-white h-[1px]" />
      <div className="flex justify-between">
        <div className="flex flex-col gap-1">
          <p>Vrijednost objekta leasinga bruto: </p>
          <p>Vrijednost objekta leasinga neto: </p>
          <p>Učešće:</p>
          <p>Kamatna stopa (%):</p>
          <p>Iznos finansiranja:</p>
        </div>
        <div className="flex flex-col items-end gap-1">
          <p>
            {formatNumber(currentOffer.grossValue)} {currentOffer.currency}
          </p>
          <p>
            {formatNumber(currentOffer.netValue)} {currentOffer.currency}
          </p>
          <p>
            {formatNumber(currentOffer.participation)} {currentOffer.currency}
          </p>
          <p>{currentOffer.interestRate}</p>
          <p>
            {formatNumber(currentOffer.netValue - currentOffer.participation)}{" "}
            {currentOffer.currency}
          </p>
        </div>
      </div>
      <Divider className="bg-white h-[1px]" />

      <div className="flex justify-between">
        <div className="flex flex-col gap-1">
          <p>Leasing rata:</p>
          <p>
            Trošak obrade ugovora (
            {(currentOffer.processingFee / currentOffer.netValue) * 100})%:
          </p>
        </div>
        <div className="flex flex-col items-end gap-1">
          <p>{formatNumber(currentOffer.installment)}</p>
          <p>
            {formatNumber(currentOffer.processingFee)} {currentOffer.currency}
          </p>
        </div>
      </div>
      <Divider className="bg-white h-[1px]" />

      <div className="flex justify-between">
        <p>EKS:</p>
        <p>{currentOffer?.eks ? currentOffer?.eks : '-'} %</p>
      </div>
      <Divider className="bg-white h-[2px]" />
      <div className="flex justify-between">
        <p>Ukupan PDV:</p>
        <p>
          {formatNumber(
            (currentOffer.installment * (currentOffer.duration * 12) -
              (currentOffer.netValue - currentOffer.participation)) *
              0.17 +
              currentOffer.netValue * 0.17
          )} {currentOffer.currency}
        </p>
      </div>
      <div className="flex justify-between">
        <p>Ukupno:</p>
        <p>
          {formatNumber(
            currentOffer.processingFee +
              ((currentOffer.installment * (currentOffer.duration * 12) -
                (currentOffer.netValue - currentOffer.participation)) *
                0.17 +
                currentOffer.netValue * 0.17) +
              currentOffer.participation
          )} {currentOffer.currency}
        </p>
      </div>
      <Divider className="bg-white h-[2px]" />
    </Modal>
  );
};

export default OfferDetailsModal;
